import { render, staticRenderFns } from "./publicationList.vue?vue&type=template&id=20c18684&scoped=true"
import script from "./publicationList.vue?vue&type=script&lang=js"
export * from "./publicationList.vue?vue&type=script&lang=js"
import style0 from "./publicationList.vue?vue&type=style&index=0&id=20c18684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c18684",
  null
  
)

export default component.exports